import { IValidationError } from './interfaces/ValidationError';

interface IParams {
  value: string,
  fieldName: string,
  fieldCaption: string,
  maxDecimals: number,
  maxWholeValue?: number,
}

export const validateNumberWithDecimals = (params: IParams): IValidationError => {
  if (params.value) {
    if (!/^(0(?!\d)|[1-9]\d*)(\.\d+)?$/.test(params.value)) {
      return { [params.fieldName]: `Invalid ${ params.fieldCaption }` };
    }

    if (params.maxWholeValue && Math.trunc(Number(params.value)) > params.maxWholeValue) {
      const maxValue = params.maxDecimals === 0 ? (params.maxWholeValue.toLocaleString('en-US')) : (
        `${ params.maxWholeValue.toLocaleString('en-US') }.${ '9'.repeat(params.maxDecimals) }`
      );

      return { [params.fieldName]: `${ params.fieldCaption } cannot be greater than ${ maxValue }` };
    }

    if (
      (params.maxDecimals || params.maxDecimals === 0)
      && params.value.includes('.')
      && params.value.split('.')[1].length > params.maxDecimals
    ) {
      return params.maxDecimals === 0 ? (
        { [params.fieldName]: `${ params.fieldCaption } cannot have decimals` }
      ) : (
        { [params.fieldName]: `${ params.fieldCaption } can have maximum ${ params.maxDecimals } decimals` }
      );
    }
  }

  return null;
};
